import { Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { showInfoState, summaryState } from "../../../recoil";

const ToolbarInfo = () => {

    const { t, i18n } = useTranslation('booking');

    const summary = useRecoilValue(summaryState);
    const showInfo = useRecoilValue(showInfoState);

    const numberFormatter = Intl.NumberFormat(i18n.language);

    const showSummaryDays = (days: number | undefined) => {

        return days !== undefined ? ` (${numberFormatter.format(days)} ${t('label.summaryDays')})` : '';
    }

    return showInfo ? (
        <Stack direction="row" alignItems="center" columnGap={1.5} px={2} py={.5} overflow="hidden">
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.total')}:</Typography>
                    <Typography>{summary?.total || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.totalDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.pending')}:</Typography>
                    <Typography>{summary?.pending || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.pendingDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.rejected')}:</Typography>
                    <Typography>{summary?.rejected || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.rejectedDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.offers')}:</Typography>
                    <Typography>{summary?.offers || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.offersDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.confirmed')}:</Typography>
                    <Typography>{summary?.confirmed || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.confirmedDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.assigned')}:</Typography>
                    <Typography>{summary?.assigned || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.assignedDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.cancelled')}:</Typography>
                    <Typography>{summary?.cancelled || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.cancelledDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.fulfilled')}:</Typography>
                    <Typography>{summary?.fulfilled || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.fulfilledDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.fail')}:</Typography>
                    <Typography>{summary?.fail || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.failDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="column" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={1}>
                    <Typography>{t('label.draft')}:</Typography>
                    <Typography>{summary?.draft || 0}</Typography>
                </Stack>
                <Typography>{showSummaryDays(summary?.draftDays)}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
        </Stack>
    ) : <></>;
};

export default ToolbarInfo;
